import script from "./ChatSettingsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSettingsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSettingsDetails.vue?vue&type=style&index=0&id=738c489d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738c489d"]])

export default __exports__